import React,{useState, useContext} from 'react';

import {
    Row,
    Col,            
    Button, 
    Alert,   
    FormControl
} from 'react-bootstrap';
import UserContext from './../../contexts/UserContext';
import {Uploader} from '../../components';
import Utils from '../../Utils';
import axios from 'axios';

import _ from 'lodash';

const PhotoForm = (props) => {

  const [isEdit, setIsEdit] = useState(parseInt(_.get(props,'mode',0)) > 0);
  const [photo, setPhoto] = useState(_.get(props,'data.fname', _.get(props, 'data.sname', props.mode === 0 ? '' : props.pos)));
  const [size, setSize] = useState(_.get(props,'data.size', 0));
  const [removeMedia, setRemoveMedia] = useState({photo : false, audio : false, state : false});
  const [slideSize, setSlideSize] = useState({photo: _.get(props, 'data.size.photo', 0), audio : _.get(props, 'data.size.audio', 0)});
  const [title, setTitle] = useState(_.get(props,'data.title', isEdit ? 'Slide ' + props.pos : ''));
  const [audio, setAudio] = useState(_.get(props,'data.audio', ''));
  const [errMsg,setErrMsg] = useState('');
  const {getPkgSize,getAvailableSize,getMaxScormSize} = useContext(UserContext);
  
  const imagesize_in_mb =  _.get(process.env,'REACT_APP_MAX_IMAGE_SIZE',1);
  const audiosize_in_mb =  _.get(process.env,'REACT_APP_MAX_AUDIO_SIZE',1);
  const scormsize_in_mb = getMaxScormSize();//_.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  
  
  const onUploadPhoto = (attr,status) => {  
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(imagesize_in_mb)} MB. Try again with an acceptable sized file.`);
    }else{
      const file_size = (status.size/1024/1024).toFixed(1);
      setSlideSize({...slideSize, photo : file_size});
      const tot_size = parseInt(file_size) + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SVASU size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{
        setErrMsg('');
        var tmp = attr;
        setPhoto(tmp);
      } 

    }
  }

  const onUploadAudio = (attr,status) => {  
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(audiosize_in_mb)} MB. Try again with an acceptable sized file.`);
    }else{  
      let file_size = (status.size/1024/1024).toFixed(1);
      setSlideSize({...slideSize, audio : file_size});
      let tot_size = parseInt(file_size) + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SVASU size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{
        setErrMsg('');
        var tmp = attr;
        setAudio(tmp);
      }
    }
  }

  const removeImageHandler = () => {
    if(window.confirm('Are you sure to delete this image?')){
      axios.delete(Utils.apiUrl('delfile?file=' + photo), Utils.apiHeaders())
        .then(res => {
            setSlideSize({...slideSize, photo : 0});
            setRemoveMedia({...removeMedia, photo: res.data.size, state : true});
          }
        )
        .catch(err => console.log(err , "  err"));
      setPhoto('');
    }
  }

  const removeAudio = () => {    
    if(window.confirm('This will remove the audio file.. continue?')){
      axios.delete(Utils.apiUrl('delfile?file=' + audio), Utils.apiHeaders())
        .then(res => {
          setSlideSize({...slideSize, audio : 0});
          setRemoveMedia({...removeMedia, audio: res.data.size, state : true});
        })
        .catch(err => console.log("Audio Removal Error : " , err));
      setAudio('');
    }
  }
  
  const submitSlide = () => {  
    if(title === ''){
      alert("Please enter title.");
      return;
    }else if (parseInt(photo) == 0 || photo === ''){
      alert("Please select image.");
      return;
    }
    else{
      if(_.get(props.data, 'fileStep', false)){
        const slideData = {...props.data, title: title, audio: audio};        
        props.onFinalize(slideData, 'Photo', (removeMedia || props.mode) ? true : false);
      }else{
        props.onFinalize({
          fname: photo,
          size: {photo : slideSize.photo, audio : slideSize.audio},
          title: title,
          audio: audio,
          manual: isEdit ? _.get(props,'data.manual', false) : true
        },'Photo', (removeMedia.state || props.mode) ? true : false);
      }
    }    
  }

  return <>
  <div className="photoedit popcotentpad">
    <Row className="m-3">      
      <Col sm={12}>        
        <FormControl placeholder="* Slide title" defaultValue={title} onChange={(e) => {setTitle(e.currentTarget.value)}} /></Col>
    </Row>
    {(!isEdit || photo == '') && <Row className="mx-3">      
      <Col title="Select File" sm={12} className="text-left" style={{overflow: 'auto'}}>
        <p><strong>Image</strong> <i className="img icon"></i></p>
        <Uploader 
        instructions={`Click the icon or drag and drop the file to upload your image file. Max file size allowed is ${getAvailableSize(imagesize_in_mb)} MB. Supported file formats are .jpg and .png only.`}
        accept="image/*" 
        maxSizeBytes={getAvailableSize(imagesize_in_mb)*1024*1024} 
        uploadUrl={Utils.apiUrl('saveupload')} 
        onUpload={onUploadPhoto} />        
      </Col>    
    </Row>} 
    {isEdit && <Row className="mx-3">
    
      {photo && <>
          
          <Col sm={12} className="text-center" style={{overflow: 'auto'}} >
            {((_.get(props.data, 'fileStep', false) === false) && _.get(props,'src', false)=== false) && <img  src={Utils.apiUrl(`image?f=${photo}.jpg`)} className="logoContainer" chk="1" alt="slide" style={{width:"80%"}} />}
            {((_.get(props.data, 'fileStep', false)=== false ) && _.get(props,'src', false) && removeMedia.state === false)&& <img src={`${props.src}&nothumb=1`} className="logoContainer" chk="2"  alt="slide" style={{width:"80%"}} />}
            {(_.get(props.data, 'fileStep', false) ) && <img src={`${props.src}&nothumb=1`} className="logoContainer" alt="slide" style={{width:"80%"}} chk="3"  />}
            {((_.get(props.data, 'fileStep', false)=== false ) && removeMedia.state === true )&& <img src={Utils.apiUrl(`image?f=${photo}`)} className="logoContainer" chk="1" alt="slide" style={{width:"80%"}} />}
            {((_.get(props.data, 'fileStep', false) === false) && (_.get(props, 'data.manual',false) ) )&& <img src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} chk="4"  className="text-right photoRemove" onClick={removeImageHandler} alt="Remove" />}
          </Col>
        </>
      }
         
      </Row>}
    {errMsg!=='' && <>
      <Row className="mx-3 mb-4">  
        <Col className="text-center"><Alert variant="danger" className="p-3">
          <i className="fa fa-exclamation-circle" /> {errMsg} </Alert> 
        </Col>
      </Row>
    </>}
    <Row className="mx-3">      
      {audio==='' && <>
      <p><strong>Audio</strong> <i className="aud icon"></i></p>
        <Col title="Select File" sm={12} className="text-left" style={{overflow: 'auto'}}>
          <Uploader accept="audio/*" 
            instructions={`Click the icon or drag and drop the file to upload your audio file. Max file size allowed is ${getAvailableSize(audiosize_in_mb)} MB. Supported file formats are .mp3 and .ogg only.`}
            uploadUrl={Utils.apiUrl('saveupload')} 
            onUpload={onUploadAudio} />
        </Col>     
      </>}
      {audio!=='' && <>
        <Col sm={12} className="text-center">
          <audio controls>      
            <source src={Utils.apiUrl(`file?f=${audio}`)} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <span className="fa fa-2x fa-trash text-primary clickable ml-3 mt-2 position-absolute" title="Remove Audio" onClick={removeAudio} />
        </Col>        
      </>}
    </Row>
  <Row>
    <Col className="text-center p-2 cta">  
      <Button onClick={submitSlide} variant="success" disabled={(props.mode === 0 && photo==='')}>Save</Button>
    </Col>
  </Row>  
  </div>
  </>
}

export default PhotoForm;